import * as React from 'react';

const BigUpload = (props) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Icon / Upload">
      <path
        id="Vector"
        // eslint-disable-next-line max-len
        d="M45 37.5V45H15V37.5H10V45C10 47.75 12.25 50 15 50H45C47.75 50 50 47.75 50 45V37.5H45ZM17.5 22.5L21.025 26.025L27.5 19.575V40H32.5V19.575L38.975 26.025L42.5 22.5L30 10L17.5 22.5Z"
        fill="#121212"
      />
    </g>
  </svg>
);
export default BigUpload;
